import { Colors } from '../../../shared/theme/';
import { textStyles } from '../../../shared/theme/fonts-ppv';
import styleButton from '../../../shared/components/rbh-button/styles';

export default {
  loginBox: {
    width: '100%',
    maxWidth: '500px',
    backgroundColor: Colors.white,
    borderRadius: '10px',
    boxShadow: 'rgba(0,0,0,0.2) 0px 2px 4px',
    padding: 24,
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
  },
  iconBox: {
    width: '100%',
    maxWidth: '280px', 
    aspectRatio: '769 / 275', 
  },
  iconImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  buttonBox: {
    ...styleButton.buttonGradient,
    width: '100%'
  },
  textInner: {
    ...textStyles.body2,
    color: Colors.darkPurple,
    cursor: 'pointer',
    textDecoration: 'underline',
    textAlign: 'center',
    marginTop: 5,
  },
  flexContent: {
    display: 'inline-flex',
    width: '100%',
    gap: 8,
    marginTop: 16
  }
};
